module.exports = __webpack_public_path__ + "media/images/search-423c54d9914ef425afd5ffaf612640a0.svg";